import { marked } from 'marked'

/** Parse user-guide headings with `{#anchor-id}` suffix into HTML heading ids. */
export function parseUserGuideMarkdown(md: string): string {
  const lines = md.split('\n')
  const processed: string[] = []
  for (const line of lines) {
    const match = line.match(/^(#{1,3})\s+(.+?)\s+\{#([a-z0-9-]+)\}\s*$/i)
    if (match) {
      const level = match[1].length
      processed.push(`<h${level} id="${match[3]}">${match[2].trim()}</h${level}>`)
    } else {
      processed.push(line)
    }
  }
  return marked.parse(processed.join('\n')) as string
}

export const HELP_TOC: { id: string; label: string }[] = [
  { id: 'overview', label: 'Overview' },
  { id: 'marketer-launch-path', label: 'Marketer launch path' },
  { id: 'navigation', label: 'Navigation' },
  { id: 'configuration-master-data', label: 'Master data' },
  { id: 'configuration-families', label: 'Families' },
  { id: 'configuration-compared-attributes', label: 'Compared attributes' },
  { id: 'configuration-compliance-rules', label: 'Compliance rules' },
  { id: 'master-terms', label: 'Master terms' },
  { id: 'products', label: 'Products' },
  { id: 'distributors-and-targets', label: 'Distributors' },
  { id: 'term-watches', label: 'Term watcher' },
  { id: 'running-checks', label: 'Running checks' },
  { id: 'jobs', label: 'Jobs' },
  { id: 'findings-and-reports', label: 'Findings & reports' },
  { id: 'guided-tours', label: 'Guided tours' },
  { id: 'best-practices', label: 'Best practices' },
]
